var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Content"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/colorfilter"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colorfilter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36.6673 19.9999C36.6673 22.1666 36.2506 24.2499 35.5006 26.1388C33.584 30.9721 29.4729 34.6944 24.3895 36.0833C23.0007 36.4721 21.5284 36.6666 20.0007 36.6666C18.4729 36.6666 17.0007 36.4721 15.6118 36.0833C10.5284 34.6944 6.41732 30.9721 4.50065 26.1388C3.75065 24.2499 3.33398 22.1666 3.33398 19.9999C3.33398 10.8055 10.8062 3.33325 20.0007 3.33325C29.1951 3.33325 36.6673 10.8055 36.6673 19.9999Z",
    stroke: "#0D0D0D",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentCircle);
export default __webpack_public_path__ + "static/media/content_circle.fcbf9df3586dade5b540ff6a28753da4.svg";
export { ForwardRef as ReactComponent };